import constants from "./actionTypes";
// ACTION FOR UPDATING APP DEFAULT LENGUAGE
export const updateLanguage = (payload) => ({
  type: constants.UPDATE_LANGUAGE,
  payload,
});
